module.exports = __webpack_public_path__ + "img/jiaju5_active.72c1b5ec.png";